module.exports = __webpack_public_path__ + "img/logo-rtx.4fc135ab.svg";